import { formatPrice } from '@hooks/usePrice';
import { FREE_SHIPPING_TEXT } from './shipping/constants';

export const transformShippingPrice = (cost: number, locale = 'en'): string => {
  if (cost === undefined) {
    return '';
  }

  if (cost === 0) {
    return locale === 'fr' ? FREE_SHIPPING_TEXT.FR : FREE_SHIPPING_TEXT.EN;
  }

  return formatPrice({
    amount: cost,
    currencyCode: 'CAD',
    locale,
  });
};
